module.exports = __webpack_public_path__ + "img/checked@2x.f03702d3.png";